export default __webpack_public_path__ + "static/media/matthew-henry.ce88c00e.jpg";